import { Text } from "@medentic/polaris-react";
import "./DividerWithText.scss";

function DividerWithText({ text }: { text: string }) {
  return (
    <div className="divider-with-text">
      <div className="divider-with-text__line" />
      <div className="divider-with-text__label">
        <Text as="p" tone="subdued">
          {text}
        </Text>
      </div>
      <div className="divider-with-text__line" />
    </div>
  );
}

export default DividerWithText;
